import {GenericService} from '@/shared/xhttp';
import {Transporteur} from '@/models';

export class TransporteurService extends GenericService<Transporteur> {
}
